export const INFRACTION_CREATE_ATTACHMENT_REQUIRED_MESSAGE =
	"Informe ao menos um anexo (Auto de Infração, Notificação de Penalidade ou Comprovantes).";

export const INFRACTION_NOTICE_ATTACHMENT_REQUIRED_ON_EDIT_MESSAGE =
	"O Auto de Infração é obrigatório. Envie um arquivo para substituir o removido.";

export const INFRACTION_CREATE_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const INFRACTION_CREATE_ALLOWED_EXTENSIONS = [
	".pdf",
	".png",
	".jpeg",
	".jpg",
] as const;

export const INFRACTION_CREATE_ALLOWED_EXTENSIONS_LABEL =
	"PDF, PNG, JPEG ou JPG";

export const INFRACTION_ATTACHMENT_TYPE = {
	INFRACTION_NOTICE: 1,
	PENALTY_NOTIFICATION: 2,
	RECEIPTS: 3,
} as const;

export const INFRACTION_ATTACHMENT_TYPE_LABEL = {
	[INFRACTION_ATTACHMENT_TYPE.INFRACTION_NOTICE]: "Auto de Infração",
	[INFRACTION_ATTACHMENT_TYPE.PENALTY_NOTIFICATION]:
		"Notificação de Penalidade",
	[INFRACTION_ATTACHMENT_TYPE.RECEIPTS]: "Comprovantes",
} as const;

export const INFRACTION_API_SEVERITY = {
	LIGHT: 1,
	MEDIUM: 2,
	SEVERE: 3,
	VERY_SEVERE: 4,
} as const;

export const INFRACTION_API_SEVERITY_LABEL: Record<number, string> = {
	[INFRACTION_API_SEVERITY.LIGHT]: "Leve",
	[INFRACTION_API_SEVERITY.MEDIUM]: "Média",
	[INFRACTION_API_SEVERITY.SEVERE]: "Grave",
	[INFRACTION_API_SEVERITY.VERY_SEVERE]: "Gravíssima",
};

export const INFRACTION_AIT_LENGTH = {
	STANDARD: 10,
	ANTT: 16,
} as const;
